import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { listingDesignerKey } from '../../data/designers';

const resultIds = data =>
  (data || [])
    .filter(l => !l.attributes.deleted && l.attributes.state === 'published')
    .map(l => l.id);

const fetchPayloadCreator = async ({ slug }, thunkAPI) => {
  const { extra: sdk, rejectWithValue, dispatch } = thunkAPI;

  return sdk.listings
    .query({
      // Dhobara: five designers' listings store a key that isn't slugify(name)
      // — listingDesignerKey bridges the two (see data/designers.js).
      pub_designer: listingDesignerKey(slug),
      perPage: 48,
      page: 1,
      // Sold listings stay published with zero stock. Show them (marked
      // SOLD) rather than letting a designer's page empty out as pieces
      // sell. currentStock is needed for the badge to know.
      minStock: 0,
      stockMode: 'match-undefined',
      include: ['images', 'currentStock'],
      'fields.listing': ['title', 'price', 'deleted', 'state', 'publicData'],
      'fields.image': [
        'variants.listing-card',
        'variants.listing-card-2x',
        'variants.scaled-medium',
      ],
      'limit.images': 1,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .catch(e => rejectWithValue(storableError(e)));
};

export const fetchDesignerListings = createAsyncThunk(
  'DesignerPage/fetchDesignerListings',
  fetchPayloadCreator
);

const slice = createSlice({
  name: 'DesignerPage',
  initialState: {
    inProgress: false,
    error: null,
    currentPageResultIds: [],
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDesignerListings.pending, state => {
        state.inProgress = true;
        state.error = null;
        state.currentPageResultIds = [];
      })
      .addCase(fetchDesignerListings.fulfilled, (state, action) => {
        state.inProgress = false;
        state.currentPageResultIds = resultIds(action.payload.data.data);
      })
      .addCase(fetchDesignerListings.rejected, (state, action) => {
        state.inProgress = false;
        state.error = action.payload;
      });
  },
});

export default slice.reducer;

export const loadData = (params, search, config) => dispatch => {
  return dispatch(fetchDesignerListings({ slug: params.slug }));
};
